import { Spin } from 'antd';

export const Loading = () => {
  return <Spin className="loading-center" size="large" />;
};
